// import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './index.scss'

const Footer = () => {
  return <>
    <div className='footer'>
      <div className='footer__logo'></div>
      <div className='footer__about'>
        <div>
          <p>About us</p>
          <p>Fly Compliant, LLC specializes in regulatory compliance and provides support in all areas of operations. With years of experience we understand the complexities of operations and have built relationships with the many different regulatory agencies:</p>
          <div className='footer__about--customers'></div>
        </div>
        <div>
          <p>Contact</p>
          <p>Fly Compliant</p>
          <p>LLC 3812 Sepulveda Blvd.</p>
          <p>Torrance, California 90505</p>
          <div className='footer__tel'>Phone: 310-375-7702</div>
          <div className='footer__tel'>FAX: 310-375-7713</div>
          <a href='/contact-us' className='btn primary contact-us-wrapper'>
            <img className="icon-email" src="/assets/img/email.png" alt="" />
            Email Us</a>
        </div>
      </div>
    </div>
    <div className='privacy'>
      <p>Privacy Policy &nbsp; &nbsp; | &nbsp; &nbsp;  Terms of Service</p>
    </div>
  </>
}

export default Footer